/**
 * Office.js enum members are PascalCase strings ("GreaterThan"); the tool schemas use camelCase
 * names. Resolve the caller's value against the member names, ignoring case, so both spellings
 * work, and return the real enum member. `enumObj` is passed in (rather than read from the
 * `Excel` global here) so nothing touches Office.js until a tool runs.
 */
export function resolveEnum(label, input, fallback, enumObj, names, aliases = {}) {
    const wanted = String(input ?? fallback).toLowerCase();
    const target = (Object.hasOwn(aliases, wanted) ? aliases[wanted] : wanted).toLowerCase();
    const name = names.find((n) => n.toLowerCase() === target);
    if (name === undefined || enumObj[name] === undefined) {
        throw new Error(`Invalid ${label} "${String(input)}". Use one of: ${names.join(', ')}`);
    }
    return enumObj[name];
}
export const CELL_VALUE_OPERATORS = [
    'between',
    'notBetween',
    'equalTo',
    'notEqualTo',
    'greaterThan',
    'lessThan',
    'greaterThanOrEqual',
    'lessThanOrEqual',
];
export const TOP_BOTTOM_TYPES = ['topItems', 'bottomItems', 'topPercent', 'bottomPercent'];
export const PRESET_CRITERIA = [
    'blanks',
    'nonBlanks',
    'errors',
    'nonErrors',
    'yesterday',
    'today',
    'tomorrow',
    'lastSevenDays',
    'lastWeek',
    'thisWeek',
    'nextWeek',
    'lastMonth',
    'thisMonth',
    'nextMonth',
    'aboveAverage',
    'belowAverage',
    'equalOrAboveAverage',
    'equalOrBelowAverage',
    'oneStdDevAboveAverage',
    'oneStdDevBelowAverage',
    'twoStdDevAboveAverage',
    'twoStdDevBelowAverage',
    'threeStdDevAboveAverage',
    'threeStdDevBelowAverage',
    'uniqueValues',
    'duplicateValues',
];
export const VALIDATION_OPERATORS = [
    'between',
    'notBetween',
    'equalTo',
    'notEqualTo',
    'greaterThan',
    'lessThan',
    'greaterThanOrEqualTo',
    'lessThanOrEqualTo',
];
export const VALIDATION_ALERT_STYLES = ['stop', 'warning', 'information'];
export const CHART_SERIES_BY = ['auto', 'columns', 'rows'];
/** Lowercased alternate spellings: the two operator enums differ ("...OrEqual" vs "...OrEqualTo"). */
export const CELL_VALUE_OPERATOR_ALIASES = {
    greaterthanorequalto: 'greaterThanOrEqual',
    lessthanorequalto: 'lessThanOrEqual',
};
export const VALIDATION_OPERATOR_ALIASES = {
    greaterthanorequal: 'greaterThanOrEqualTo',
    lessthanorequal: 'lessThanOrEqualTo',
};
